import { render, staticRenderFns } from "./OrderBaseInfo.vue?vue&type=template&id=6e99ce0c&scoped=true&"
import script from "./OrderBaseInfo.vue?vue&type=script&lang=js&"
export * from "./OrderBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderBaseInfo.vue?vue&type=style&index=0&id=6e99ce0c&prod&lang=css&"
import style1 from "./OrderBaseInfo.vue?vue&type=style&index=1&id=6e99ce0c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e99ce0c",
  null
  
)

export default component.exports